/* eslint-disable react-native/no-inline-styles */
import {Button, Card, Layout, Modal, Text} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet, View, Image} from 'react-native';
import {hp, isLandscape as isLandscapeUtil, px, wp} from '../../../../utils';
import {TitleRow} from '../../../components';
import {goodNewsBanner} from '../../../../assets/images';

const AlertMessageModal = ({
  title,
  description,
  note,
  okButtonText,
  onClose,
  onConfirm,
}) => {
  const handleConfirm = () => {
    if (typeof onConfirm === 'function') {
      onConfirm();
    } else {
      onClose();
    }
  };

  return (
    <Modal
      visible={true}
      backdropStyle={styles.backdrop}
      style={{
        backgroundColor: 'transparent',
        borderRadius: 10,
        boxShadow: '10px 10px 30px -12px rgba(0,0,0,0.75)',
      }}
      onBackdropPress={() => onClose()}>
      <Card disabled={true}>
        <Layout style={styles.container}>
          <TitleRow
            title={''}
            type="primary"
            iconName="close-circle-outline"
            onIconClick={() => onClose()}
            containerStyle={styles.title}
          />
          <View style={styles.boxContainer}>
            <Image
              source={goodNewsBanner}
              style={styles.goodNewsBannerImage}
              resizeMode="contain"
            />

            <Text style={styles.primaryText}>{title}</Text>
            <Text style={styles.secondaryText}>{description}</Text>
            <Text style={styles.noteText}>{note}</Text>

            <View style={{flexDirection: 'row', justifyContent: 'center'}}>
              <View>
                <Button onPress={handleConfirm} style={styles.submitButton}>
                  {okButtonText || 'Ok'}
                </Button>
              </View>
            </View>
          </View>
        </Layout>
      </Card>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    width: isLandscapeUtil() ? wp(60) : wp(90),
    height: isLandscapeUtil() ? hp(60) : hp(90),
  },
  boxContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '80%',
  },
  backdrop: {
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
  },
  title: {
    width: '100%',
  },
  goodNewsBannerImage: {
    width: px(300),
    height: px(200),
  },
  heading: {
    fontWeight: '600',
    fontSize: 22,
    textAlign: 'center',
    marginTop: px(50),
  },
  primaryText: {
    fontWeight: '600',
    fontSize: 18,
    textAlign: 'center',
    marginTop: px(20),
  },
  secondaryText: {
    fontWeight: '500',
    textAlign: 'center',
    marginTop: px(20),
    marginBottom: px(17),
    fontSize: 16,
  },
  noteText: {
    fontWeight: '600',
    textAlign: 'center',
    marginHorizontal: px(17),
    marginBottom: px(17),
    fontSize: 15,
    color: '#FF5722',
  },
  input: {
    marginHorizontal: px(17),
    marginBottom: px(17),
  },
  submitButton: {
    marginHorizontal: px(5),
    marginTop: px(26),
    marginBottom: px(17),
    width: px(300),
  },
  rowContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    margin: px(17),
    marginTop: px(28),
  },
  infoText: {
    marginHorizontal: px(10),
    paddingVertical: px(10),
    textAlign: 'center',
    marginTop: px(16),
  },
  errorText: {
    marginHorizontal: px(17),
    borderColor: 'red',
    borderRadius: 8,
    borderWidth: 1,
    borderStyle: 'solid',
    paddingHorizontal: px(15),
    paddingVertical: px(10),
    textAlign: 'center',
    marginBottom: px(40),
  },
});

export default AlertMessageModal;
